<div class="edit-kontrolltermin-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>Kontrolltermin bearbeiten</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <!-- Kontrolltermin Info -->
    <div class="kontrolltermin-info mb-2 p-2 bg-gray-50 rounded-lg">
      <h3 class="text-sm font-semibold mb-1">Kontrolltermin</h3>
      <div class="grid grid-cols-2 gap-2 text-xs">
        <div>
          <span class="font-medium">Einsatznummer:</span>
          <span class="ml-1">{{ data.kontrolltermin.einsatznummer }}</span>
        </div>
        <div>
          <span class="font-medium">Datum:</span>
          <span class="ml-1">{{ data.kontrolltermin.datum_durchfuerung | date:'dd.MM.yyyy' }}</span>
        </div>
        <div class="col-span-2">
          <span class="font-medium">Projektaufgabe:</span>
          <div class="mt-1 text-gray-700">{{ data.kontrolltermin.projektaufgabe_beschreibung }}</div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Daten...</span>
    </div>

    <!-- Edit Form -->
    <div *ngIf="!isLoading" class="space-y-1">
      <!-- Techniker Selection -->
      <div class="form-group">
        <label class="form-label text-xs" for="techniker_id">Techniker *</label>
        <mat-select 
          [(ngModel)]="selectedTechnikerId"
          id="techniker_id"
          class="w-full"
          placeholder="Techniker auswählen">
          <mat-option *ngFor="let techniker of technikerOptions" [value]="techniker.id">
            {{ techniker.display_name }}
            <span *ngIf="techniker.nummer" class="text-gray-500 ml-1 text-xs">({{ techniker.nummer }})</span>
          </mat-option>
        </mat-select>
        <div *ngIf="!selectedTechnikerId" 
             class="text-red-500 text-xs mt-1">
          Bitte wählen Sie einen Techniker aus
        </div>
      </div>

      <!-- Status Selection -->
      <div class="form-group">
        <label class="form-label text-xs" for="status_id">Status *</label>
        <mat-select 
          [(ngModel)]="selectedStatusId"
          id="status_id"
          class="w-full"
          placeholder="Status auswählen">
          <mat-option *ngFor="let status of statusOptions" [value]="status.id">
            <span class="inline-flex items-center">
              <span class="w-2 h-2 rounded-full mr-1" 
                    [ngClass]="getStatusBadgeClass(status.id)"></span>
              <span class="text-xs">{{ status.label }}</span>
            </span>
          </mat-option>
        </mat-select>
        <div *ngIf="!selectedStatusId" 
             class="text-red-500 text-xs mt-1">
          Bitte wählen Sie einen Status aus
        </div>
      </div>

      <!-- Current Values Display -->
      <div class="current-values p-1 bg-blue-50 rounded-lg">
        <h4 class="font-medium text-blue-900 mb-1 text-xs">Aktuelle Werte:</h4>
        <div class="text-xs text-blue-800">
          <div><strong>Techniker:</strong> {{ getTechnikerName(data.kontrolltermin.techniker_id) }}</div>
          <div><strong>Status:</strong> {{ getStatusLabel(data.kontrolltermin.status_id) }}</div>
        </div>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" [disabled]="isSaving">
      Abbrechen
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()" 
      [disabled]="!selectedTechnikerId || !selectedStatusId || isSaving">
      <mat-spinner *ngIf="isSaving" diameter="20" class="mr-2"></mat-spinner>
      {{ isSaving ? 'Wird gespeichert...' : 'Speichern' }}
    </button>
  </div>
</div>
